import { ReactElement, SVGProps } from 'react';
import BaseIcon from "./BaseIcon";

export default function BadgeIcon(props: SVGProps<any>): ReactElement {
  return (
    <BaseIcon {...props} viewBox="0 0 20 20">
      <path
        d="M5 15.903h5v-.375q0-.354-.198-.657a1.3 1.3 0 0 0-.552-.468 4.3 4.3 0 0 0-.844-.282 4.2 4.2 0 0 0-.906-.093q-.48 0-.906.093a4.3 4.3 0 0 0-.844.282q-.354.166-.552.468T5 15.529zm7.292-1.25h2.083a.607.607 0 0 0 .625-.625.607.607 0 0 0-.625-.625h-2.083a.607.607 0 0 0-.625.625.607.607 0 0 0 .625.625M7.5 13.403q.52 0 .885-.365.365-.364.365-.885 0-.522-.365-.886a1.2 1.2 0 0 0-.885-.364q-.52 0-.885.364a1.2 1.2 0 0 0-.365.886q0 .52.365.885t.885.365m4.792-1.25h2.083a.607.607 0 0 0 .625-.625.607.607 0 0 0-.625-.625h-2.083a.607.607 0 0 0-.625.625.607.607 0 0 0 .625.625m-8.959 7.083q-.687 0-1.177-.49a1.6 1.6 0 0 1-.49-1.177V8.403q0-.688.49-1.177t1.177-.49H7.5v-2.5q0-.687.49-1.177.489-.49 1.177-.49h1.666q.688 0 1.177.49t.49 1.177v2.5h4.167q.687 0 1.177.49.49.489.49 1.177v9.166q0 .688-.49 1.178t-1.177.49zM9.167 8.403h1.666V4.236H9.167z"
        fill="currentColor"
      />
    </BaseIcon>
  )
}
